module.exports = __webpack_public_path__ + "static/Fixed-Columns-a0f0a513a32f0a6a76d2b8d0e9080819.png";